module.exports = __webpack_public_path__ + "static/media/travel_img.a78b4415.png";